<template>
  <div>
    <div class="box">
      <admin-box-item title="SMS 메세지 전송" subtitle="고객에게 SMS메세지를 직접 입력하며 전송할 수 있습니다.">
        <div class="columns is-multiline" v-if="!$route.query.id">
          <div class="column is-6" :style="smsTextAreaStyle">
            <admin-form-item label="전송내용">
              <div class="sms-textarea-wrapper">
                <div v-if="value.advertisement" style="white-space: pre-line">{{ ad_text }}</div>
                <textarea class="textarea sms-textarea" v-model="value.msg" placeholder="내용을 입력하세요."
                          @input="inputMsg"></textarea>
                <div v-if="value.advertisement" style="white-space: pre-line">{{ ad_text2 }}</div>
              </div>
            </admin-form-item>
            <div>{{ bytes }} bytes (90Bytes 이상인 경우 LMS로 전송됩니다. 최대 2,000bytes)</div>
            <div class="advertisement-confirm" v-if="value.advertisement">광고 문자로 발송합니다. 실제 발송되는 문자 내용의 길이가 다를 수 있습니다.</div>
          </div>
          <div class="column is-6">
            <admin-form-item label="전송 대상">
              <lp-radio :val.sync="value.target"
                        value_name="value"
                        label_name="label"
                        :data="[{label:'일반회원',value:0}, {label:'마케팅정보수신동의회원', value:2}]"></lp-radio>
            </admin-form-item>
            <div class="flex-align">
              <admin-form-item label="광고성 정보" style="margin-bottom: 0">
                <lp-radio :val.sync="value.advertisement"
                          value_name="value"
                          label_name="label"
                          :data="[{label:'Y',value:true}, {label:'N', value:false}]"></lp-radio>
              </admin-form-item>
            </div>
          </div>
        </div>

        <div class="columns is-multiline" v-if="$route.query.id">
          <div class="column is-6">
            <admin-form-item label="전송내용">
              <div class="msg-box">
                {{ value.msg }}
              </div>
            </admin-form-item>
          </div>
          <div class="column is-6">
            <admin-form-item label="전송 대상">
              {{ value.target===0?'전체회원':value.target===1?'일반회원':'마케팅수신동의회원' }}
            </admin-form-item>
            <admin-form-item label="용량">
              {{ value.type==='sms'?'단문문자':'장문문자' }}
            </admin-form-item>
            <admin-form-item label="광고성 정보">
              {{ value.advertisement?'Y':'F' }}
            </admin-form-item>
          </div>
        </div>
      </admin-box-item>
    </div>
    <!-- 저장 -->
    <div class="btn-group-justify-end" v-if="!$route.query.id">
      <button class="button is-primary" @click="sendValidCheck">전송</button>
    </div>

    <modal name="sendModal" :adaptive="true" :width="400" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <div style="text-align: center;padding:36px">메세지를 전송하시겠습니까?</div>
        <div class="flex-center">
          <button class="button is-primary" @click="saveData">예(Y)</button>
          <button class="button"
                  style="background-color:#A0A0A0;color:white;margin-left:12px"
                  @click="$modal.hide('sendModal')">아니요(N)</button>
        </div>
      </div>
    </modal>

    <modal name="sendConfirmModal" :adaptive="true" :width="400" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <div style="text-align: center;padding:36px">메세지가 고객에게 발송되었습니다.</div>
        <div class="flex-center">
          <button class="button is-primary" @click="hideConfirmModal">확인</button>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
  import LpRadio from "../../module/common/LpRadio";

  export default {
    name: "SmsCreate",
    components: {LpRadio},
    mounted() {
      this.ad_text = '[Web발신]\n' +
        `(광고) ${this.$store.getters.serviceName}`;
      this.ad_text2 = `무료수신거부\n` +
        `080-600-5653`;
      this.getData();
    },
    data() {
      return {
        value: {
          target: 0,
          type: 'sms',   // 단문, 장문
          advertisement: false,
          sms_agreement: false,
          msg: ''
        },
        bytes: 0,
        ad_text: '',
        ad_text2: ''
      }
    },
    computed: {
      smsTextAreaStyle() {
        let styl = {};
        if(this.$store.getters.device==='pc') styl.minWidth = '450px';
        return styl;
      }
    },
    watch: {
      'value.advertisement'(n) {
        if(this.value.advertisement) {
          this.bytes = this.getByte(this.ad_text + '\n' + this.value.msg + this.ad_text2);
        } else {
          this.bytes = this.getByte(this.value.msg);
        }
      }
    },
    methods: {
      inputMsg(e) {
        let value = e.target.value;
        // 광고성 수신 동의
        if(this.value.advertisement) {
          this.bytes = this.getByte(this.ad_text + '\n' + value + this.ad_text2);
        } else {
          this.bytes = this.getByte(value);
        }
        this.value.msg = value;
        /*if(this.bytes>=2000) {
          this.value.msg = this.cutByte(value, 2000);
          this.bytes = this.getByte(this.value.msg);
        } else {
          this.value.msg = value;
        }*/
      },
     /* getByte(str) {
         return str
           .split('')
           .map(s => s.charCodeAt(0))
           .reduce((prev, c) => (prev + ((c === 10) ? 2 : ((c >> 7) ? 2 : 1))), 0);
       },*/
      getByte(str) {
        var length = 0;
        for(var i = 0; i < str.length; i++)
        {
          if(escape(str.charAt(i)).length >= 4)
            length += 2;
          else if(escape(str.charAt(i)) == "%A7")
            length += 2;
          else
          if(escape(str.charAt(i)) != "%0D")
            length++;
        }
        return length;
      },
      cutByte(str, len) {
        var count = 0;

        for(var i = 0; i < str.length; i++) {
          if(escape(str.charAt(i)).length >= 4)
            count += 2;
          else
          if(escape(str.charAt(i)) != "%0D")
            count++;

          if(count >  len) {
            if(escape(str.charAt(i)) == "%0A")
              i--;
            break;
          }
        }
        return str.substring(0, i);
      },
      sendValidCheck() {
        if(!this.value.msg) {
          this.toast('전송내용을 입력하세요.');
          return;
        }
        let blank_pattern = /^\s+|\s+$/g;
        if(this.value.msg.replace( blank_pattern, '' ) === "" ){
          this.toast(' 공백만 입력되었습니다 ');
          return;
        }
        this.$modal.show('sendModal');
      },
      saveData() {
        if(this.bytes>2000) {
          this.toast('최대 2,000bytes까지만 전송이 됩니다.');
          return;
        }
        let params = this.cloneItem(this.value);
        if(this.bytes>90) {
          params.type = 'lms';
        }
        if(this.value.advertisement) {
          params.msg = this.ad_text + '\n' + params.msg + '\n' + this.ad_text2;
        }
        let url = 'admin/sms/send/multiple';
        this.$axios.post(url, params).then(res => {
          this.$modal.hide('sendModal');
          this.$modal.show('sendConfirmModal');
        }).catch(error => {
          this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
        })
      },
      hideConfirmModal() {
        this.$modal.hide('sendConfirmModal');
        this.$router.replace(this.getPath('sms'));
      },
      getData() {
        if(!this.$route.query.id) return;
        let url = `admin/sms/send/multiple/${this.$route.query.id}`;
        this.$axios.get(url).then(res => {
          this.value = res.data;
        })
      }
    }
  }
</script>
<style lang="stylus" scoped>
  .sms-textarea-wrapper
    border 1px solid #ddd
    border-radius 4px
    padding 6px

  .sms-textarea
    border 0
    box-shadow none
    padding 0
    resize none

  .advertisement-confirm
    color red
    font-size .9rem

  .msg-box
    border 1px solid #CCCCCC
    border-radius 4px
    padding 14px
    min-height 350px
    height 350px
    overflow scroll
</style>
